// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export');
var toISOString = require('./_date-to-iso-string');

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.date.to-iso-string.js
// module id = 158
// module chunks = 1